import * as angular from 'angular';
import { loadGoogleVisualizationApi } from '../../lib/load-google-visualization-api';

export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $timeout,
        $translate,
        Alert,
        CompanyApplicationOverviewService,
        UserAccountsService,
    ) {
        this.$state=$state;
        this.$timeout=$timeout;
        this.$translate=$translate;
        this.Alert = Alert;
        this.UserAccountsService=UserAccountsService;
        this.CompanyApplicationOverviewService=CompanyApplicationOverviewService;
    }
    $onChanges () {

    const companyId = this.companyId = this.$state.params.companyId;
      
   this.applicationId=this.application.id;   
   this.displayChartSpinner = false;
   this.displaySeparator = false;
   this.displayCharts = false;
   this.startDate = new Date();
   this.endDate = new Date();
   this.userFilter = -1;
   this.periodFilter = 'TODAY';
   this.dataFilter = 'DAY';
   this.saaspassId="";
   this.oneTimePassword = true;
   this.instatntLogin = true;
   this.proximity = true;
   this.remoteLogin = true;
   this.ssoLogin = true;
   this.app2appLogin = true;
   this.showSelectors = false;
    var chart;
    var chart2;
    var realData;
    var realData2;
    var colors = ['#FE2E2E', '#F5A9A9','#0040FF', '#5882FA','#DBA901', '#F3E2A9'];
    var options = {
        curveType : 'none',
        legend : {
            position : 'top',
            maxLines: 2,
            alignment : 'center'
        },
        colors: colors,
        height : 400,
        pointSize: 3,
        chartArea : {
            width : '90%'
        },
        hAxis : {
            showTextEvery : 4,
            slantedText : true,
            slantedTextAngle : 60,
            textStyle : {
                fontSize : 10
            }
        },
        vAxis: {
            maxValue: 4, 
            format: 'short'
        },
        animation : {
            startup : true,
            duration : 700,
            easing : 'linear'
        }
    };
    
        this.UserAccountsService.assignedGroups.get({
            companyId : companyId,
            appId :this.applicationId
        }).$promise.then((data) => {           
           this.assignedGroups = data.assignedGroups;
        });

   this.datepickerOptions = {maxDate: new Date()};
   this.open = ($event, type) => {
        $event.preventDefault();
        $event.stopPropagation();
        if (type == 1) {
           this.opened = true;
           this.opened1 = false;
        } else {
           this.opened1 = true;
           this.opened = false;
        }
    };

   this.generateReport = () => {
	   this.displayCharts = true;
       if (this.periodFilter === 'CUSTOM' && this.endDate < this.startDate) {
            this.Alert('danger', 'corporate.sms.date_message_warning');
            return;
        }
        
       this.displayChartSpinner = true;  
        clearChekboxs();
        
        var chart_data = [ [ this.$translate.instant('configure_application.year'), this.$translate.instant('configure_application.application_usage.generate_report.otp_successful'), this.$translate.instant('configure_application.application_usage.generate_report.otp_total'),
                       this.$translate.instant('configure_application.application_usage.generate_report.scan_barcode_successful'), this.$translate.instant('configure_application.application_usage.generate_report.scan_barcode_total'),
                this.$translate.instant('configure_application.application_usage.generate_report.proximity_successful'), this.$translate.instant('configure_application.application_usage.generate_report.proximity_total') ] ];
        var chart_data2 = [ [ this.$translate.instant('configure_application.year'), this.$translate.instant('configure_application.application_usage.generate_report.remote_successful'),this.$translate.instant('configure_application.application_usage.generate_report.remote_total'), 
                              this.$translate.instant('configure_application.application_usage.generate_report.sso_successful'), this.$translate.instant('configure_application.application_usage.generate_report.sso_total'),
                              this.$translate.instant('configure_application.application_usage.generate_report.mobile_successful'), this.$translate.instant('configure_application.application_usage.generate_report.mobile_login') ] ];
        var dateVar = new Date();
        var timeZone = dateVar.getTimezoneOffset() / 60 * (-1);
        this.CompanyApplicationOverviewService.drawChart.query({
            companyId : companyId,
            appId :this.applicationId,
            filterUser :this.userFilter,
            periodFilter :this.periodFilter,
            displayData :this.dataFilter,
            saaspassId :this.saaspassId,
            startDate: +this.startDate,
            endDate: +this.endDate,
            timeZone : timeZone
        }).$promise.then((data) => {
            for (var i = 0; i < data.length; i++) {
                var row = data[i];
                var points = [ row[0], row[1], row[2], row[3], row[4], row[5], row[6] ];
                chart_data.push(points);
                var points2 = [ row[0], row[7], row[8], row[9], row[10], row[11], row[12] ];
                chart_data2.push(points2);
            }
            chart = createChart(chart_data, 'curve_chart');
            chart2 = createChart(chart_data2, 'curve_chart2');
            
        }, (error) => {
           this.displayChartSpinner = false;
        });
    }
    
    var createChart =  (chartData, chartName) => {
        return loadGoogleVisualizationApi().then((google) => {

        var data_graph = google.visualization.arrayToDataTable(chartData);
        
        var max = 4;
        var max2 = data_graph.getColumnRange(2).max;
        var max4 = data_graph.getColumnRange(4).max;
        var max6 = data_graph.getColumnRange(6).max;            
        max = Math.max(max,max2,max4,max6);
        while (max % 4 != 0) {
            max++;
        }
        options.vAxis.maxValue = max;
         var vGrid = max;
        if (max > 256) {
            vGrid = 4;
        } else if (max > 128) {
            vGrid = 6;
        } else if (max > 64) {
            vGrid = 8;
        } else if (max > 32) {
            vGrid = 10;
        } else if (max > 16) {
            vGrid = 8;
        } else if (max > 8) {
            vGrid = 6;
        } else if (max > 4) {
            vGrid = 4;
        } 
        options.vAxis.gridlines = { count: vGrid };
        var showEvery = parseInt(data_graph.getNumberOfRows() / 10);
        options.hAxis.showTextEvery = showEvery;
        //copyData = angular.copy(data_graph);
        if (chartName == "curve_chart") {
            realData = angular.copy(data_graph);
        } else {
            if (this.application.applicationType.slug !== 'custom') {
                var data_colors = angular.copy(colors);
                data_colors.splice(0, 2);
                data_graph.removeColumn(5);
                data_graph.removeColumn(5);
               this.app2appLogin = false;
                $('#app2appDiv').hide();
                options.colors = data_colors;
            }
            realData2 = angular.copy(data_graph);
        }
        var newChart = new google.visualization.LineChart(document.getElementById(chartName));
       this.selectHandler = () => {
           this.displayChartSpinner = false;
           this.showSelectors = true;
           this.displaySeparator = true;
        }
        google.visualization.events.addListener(newChart, 'ready', this.selectHandler);
        newChart.draw(data_graph, options);
        return newChart;
        });
    }

    var clearChekboxs =  () => {
       this.oneTimePassword = true;
       this.instatntLogin = true;
       this.proximity = true;
        $('#proximity').prop('disabled', false);
        $('#instatntLogin').prop('disabled', false);
        $('#oneTimePassword').prop('disabled', false);

       this.remoteLogin = true;
       this.ssoLogin = true;
       this.app2appLogin = true;
        $('#remoteLogin').prop('disabled', false);
        $('#ssoLogin').prop('disabled', false);
        $('#app2appLogin').prop('disabled', false);

        options.colors = colors;
    }

   this.removeColumnInChart =  () => {

        var n = 0;
        var k = 0;
        var data_graph = angular.copy(realData);
        var data_colors = angular.copy(colors);
        if (!this.oneTimePassword) {
            data_colors.splice(0, 2);
            data_graph.removeColumn(1);
            data_graph.removeColumn(1);
            n = 2;
        }

        if (!this.instatntLogin) {
            data_colors.splice(2 - n, 2);
            data_graph.removeColumn(3 - n);
            data_graph.removeColumn(3 - n);
            k = 2;
        }

        if (!this.proximity) {
            data_colors.splice(4 - n - k, 2);
            data_graph.removeColumn(5 - n - k);
            data_graph.removeColumn(5 - n - k);
        }
        options.colors = data_colors;
        chart.then((chart) => chart.draw(data_graph, options));

        $('#proximity').prop('disabled', false);
        $('#instatntLogin').prop('disabled', false);
        $('#oneTimePassword').prop('disabled', false);
        if(!this.oneTimePassword && !this.instatntLogin){
            $('#proximity').prop('disabled', true);
        }else if(!this.oneTimePassword && !this.proximity){
            $('#instatntLogin').prop('disabled', true);
        }if(!this.instatntLogin && !this.proximity){
            $('#oneTimePassword').prop('disabled', true);
        }

    }

   this.removeColumnInChart2 =  () => {

        var n = 0;
        var k = 0;
        var data_graph = angular.copy(realData2);
        var data_colors = angular.copy(colors);
        if (!this.remoteLogin) {
            data_colors.splice(0, 2);
            data_graph.removeColumn(1);
            data_graph.removeColumn(1);
            n = 2;
        }

        if (!this.ssoLogin) {
            data_colors.splice(2 - n, 2);
            data_graph.removeColumn(3 - n);
            data_graph.removeColumn(3 - n);
            k = 2;
        }

       if (this.app2appLogin && this.application.applicationType.slug !== 'custom') {
            data_colors.splice(4 - n - k, 2);
            data_graph.removeColumn(5 - n - k);
            data_graph.removeColumn(5 - n - k);
        }
        options.colors = data_colors;
        chart2.then((chart) => chart.draw(data_graph, options));
        
        $('#remoteLogin').prop('disabled', false);
        $('#ssoLogin').prop('disabled', false);
        $('#app2appLogin').prop('disabled', false);
        if(!this.remoteLogin && !this.ssoLogin){
            $('#app2appLogin').prop('disabled', true);
        }else if(!this.remoteLogin && !this.app2appLogin){
            $('#ssoLogin').prop('disabled', true);
        }if(!this.ssoLogin && !this.app2appLogin){
            $('#remoteLogin').prop('disabled', true);
        }
        
    }
    };
}



// WEBPACK FOOTER //
// ./src/portal/components/application-usage-report/application-usage-report.controller.js